import dot from 'dot-object';

export function parseIt(obj: any) {
  // NULL and undefined check
  if ([undefined, null].includes(obj)) {
    return obj;
  }

  // Check for circular reference
  let parsed;
  try {
    parsed = JSON.parse(JSON.stringify(obj));
  } catch (e) {
    throw new Error('Cannot parse object with circular reference');
  }

  // Process dotted keys at top-level
  try {
    parsed = dot.object(parsed);
  } catch (e) {
    throw new Error(`dotObject threw a parsing error: ${e.message}`);
  }

  // Find child objects
  for (const [key, value] of Object.entries(parsed)) {
    // Process an object recursively
    if (typeof value === 'object') {
      (parsed as any)[key] = parseIt(value);
    }
  }

  return parsed;
}
